
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { TableDownstreamSheetsQueryVariables, TableDownstreamSheetsQuery, SheetsDisplayGridRowDataFragment, TableDownstreamSheetsFilteredByColumnQueryVariables, TableDownstreamSheetsFilteredByColumnQuery, SheetSortOrder , TableDownstreamSheetsFilteredByColumnDocument , TableDownstreamSheetsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import { getRowDataForSheet, SheetsDisplayGrid, SheetsDisplayGridRowData } from '../sharedDisplayGrid/SheetsDisplayGrid';
import { SheetsValidSortFields } from '../sorting/sortProviders/SheetsGridSortProvider';

type QueryVariables = TableDownstreamSheetsQueryVariables;
type QueryResults = TableDownstreamSheetsQuery;
type QueryResultListNode = SheetsDisplayGridRowDataFragment;
type GridRowData = SheetsDisplayGridRowData;

type QueryVariablesWithFilter = TableDownstreamSheetsFilteredByColumnQueryVariables;
type QueryResultsWithFilter = TableDownstreamSheetsFilteredByColumnQuery;
type QueryResultListNodeWithFilter = SheetsDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tables && resultData.tables[0] &&
    resultData.tables[0].downstreamSheetsConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  return resultData && resultData.columns && resultData.columns[0] &&
    resultData.columns[0].downstreamSheetsConnection;
}

export type TableDownstreamSheetsQueryGridProps =
  GridSortProps<SheetsValidSortFields> & {
    readonly tableId: string;
    readonly filteredColumnId: string | null;
    readonly rowCount: number | null;
  };

export function TableDownstreamSheetsQueryGrid(props: TableDownstreamSheetsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamSheetsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredSheetsLineageGridMessage();

  return props.filteredColumnId ? (
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
      queryGql={TableDownstreamSheetsFilteredByColumnDocument}
      partialQueryVariables={{ columnId: props.filteredColumnId, orderBy: props.orderBy as SheetSortOrder }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForSheet}
    >
      {({ rowStore }) => <SheetsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={TableDownstreamSheetsDocument}
      partialQueryVariables={{ tableId: props.tableId, orderBy: props.orderBy as SheetSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForSheet}
    >
      {({ rowStore }) => <SheetsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );
}
